module.exports = __webpack_public_path__ + "static/media/Artboard.4fbdb1bf.png";